import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from "react-select";
import ConfirmDialog from '../../../components/ConfirmDialog';

function Coupon() {

  const [showForm, setShowForm] = useState(false);
  const [partyMaster, setPartyMaster] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const [sources, setSources] = useState(["Online", "Store"]);
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [newSourceName, setNewSourceName] = useState("");
  const [stateOptions, setStateOptions] = useState([]);
  const [address, setAddress] = useState([]);
  const [coupon, setCoupon] = useState([]);

  const [form, setForm] = useState({
    coupon_name: '',
    coupon_code: '',
    state: '',
    city: '',
    discount_type: '',
    discount_value: '',
    order_value: '',
  })

  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null,
  });



  const [cities, setCities] = useState([]);

  const discountOptions = [
    { value: "Amount", label: "Amount" },
    { value: "Percentage", label: "Percentage" },
  ];

  const handleAddClick = () => {
    setShowForm(true);
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const showConfirmDialog = ({ title, message, onConfirm }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({ ...confirmDialog, show: false });
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (isEditMode) {
      const sendData = new FormData();

      sendData.append("coupon_name", form.coupon_name);
      sendData.append("coupon_code", form.coupon_code);
      sendData.append("state", form.state);
      sendData.append("city", form.city);
      sendData.append("discount_value", form.discount_value);
      sendData.append("discount_type", form.discount_type);
      sendData.append("order_value", form.order_value);


      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-coupon/${form.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Coupon updated successfully!', 'success');
        setShowForm(false);

        fetchCoupon();
        setForm({
          coupon_name: '',
          coupon_code: '',
          state: '',
          city: '',
          discount_type: '',
          discount_value: '',
          order_value: '',
        })
      } catch (err) {
        showToast('Fail to update party!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    } else {
      const sendData = new FormData();

      sendData.append("coupon_name", form.coupon_name);
      sendData.append("coupon_code", form.coupon_code);
      sendData.append("state", form.state);
      sendData.append("city", form.city);
      sendData.append("discount_value", form.discount_value);
      sendData.append("discount_type", form.discount_type);
      sendData.append("order_value", form.order_value);

      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-coupon",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Coupon Added successfully!', 'success');
        setShowForm(false);
        fetchCoupon();

        setForm({
          coupon_name: '',
          coupon_code: '',
          state: '',
          city: '',
          discount_type: '',
          discount_value: '',
          order_value: '',
        })
      } catch (err) {
        showToast('Fail to add  party!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    }

  };

  const fetchStates = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/get-states");
      setStateOptions(res.data);

    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCoupon = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-coupon");
      setCoupon(res.data);

    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };


  const fetchDataByState = async (state) => {
    if (!state) return;

    try {
      const response = await axios.get(
        `https://api.skyguard.group/api/get-state-data?state=${encodeURIComponent(state)}`
      );

      const data = response.data;
      if (!data || data.length === 0) {
        setCities([]);
        showToast("No city available for this state", "warning");
        return;
      }
      const cityList = [...new Set(data.map(item => item.city))];
      setCities(cityList);


    } catch (error) {
      console.error("Error fetching cities by state:", error);
    }
  };

  useEffect(() => {
    fetchDataByState();
    fetchStates();
    fetchCoupon();
  }, []);



  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.skyguard.group/api/delete-coupon/${id}`);
      showToast("Coupon deleted successfully");
      fetchCoupon();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete coupon");

    }
  };

  const handleEdit = (form) => {

     if (form.city && !cities.includes(form.city)) {
      setCities(prev => [...prev, form.city]);
    }

    setForm({
      id: form.id || '',
      coupon_name: form.coupon_name || '',
      coupon_code: form.coupon_code || '',
      state: form.state || '',
      // city:form.city || '',
      city: form.city ? form.city.trim() : '',
      discount_type: form.discount_type || '',
      discount_value: form.discount_value || '',
      order_value: form.order_value || '',
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


  const filteredData = coupon.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )

  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Coupon Section</h3>



        <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

          <div className="mb-2 w-50 w-md-50 pe-md-2">
            <input
              className="form-control w-100"
              list="datalistOptions"
              placeholder="Search ...."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <button className="btn btn-success" onClick={handleAddClick}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>


        {showForm && (


          <div className='card p-3 mb-3  w-75 mx-auto'>
            <form onSubmit={handleSubmit} >

                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.coupon_name}
    </span>
  </div>
)}

              <hr />

              <div className='row g-3'>

                <div className="col-md-6">
                  <label htmlFor='name' className="form-label fw-medium" >Coupan Name </label>
                  <input type="text" className="form-control" name="coupon_name" placeholder="Enter here..." value={form.coupon_name} onChange={handleInputChange} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" > Coupan Code </label>
                  <input type="text" className="form-control" name="coupon_code" placeholder="Enter here..."
                    value={form.coupon_code}
                    onChange={handleInputChange}
                    required

                  />
                </div>


                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >State </label>

                  <select
                    className="form-select"
                    name="state"
                    value={form.state}
                    onChange={(e) => {
                      const selectedState = e.target.value;
                      setForm({ ...form, state: selectedState });
                      fetchDataByState(selectedState);
                    }}
                    required

                  >
                    <option value="">Select State</option>
                    {stateOptions.map((state) => (
                      <option key={state} value={state}>{state}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >City </label>
                  <select
                    className="form-select"
                    value={form.city}
                    onChange={(e) => setForm({ ...form, city: e.target.value })}
                  >
                    <option value="">Select City</option>
                    {cities.map((city, index) => (
                      <option key={index} value={city}>{city}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label htmlFor="discount_type" className="form-label fw-medium">
                    Discount Type
                  </label>
                  <Select
                    id="discount_type"
                    name="discount_type"
                    options={discountOptions}
                    value={discountOptions.find(opt => opt.value === form.discount_type) || null}
                    onChange={(selectedOption) =>
                      setForm((prev) => ({ ...prev, discount_type: selectedOption?.value || "" }))
                    }
                    placeholder="Select Discount Type"
                  />
                </div>


                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >Discount Value </label>
                  <input type="number" className="form-control" name="discount_value" placeholder="Enter here..."
                    value={form.discount_value}
                    onChange={handleInputChange}

                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >Order Value </label>
                  <input type="number" className="form-control" name="order_value" placeholder="Enter here..."
                    value={form.order_value}
                    onChange={handleInputChange}

                  />
                </div>
                <div className='gap-2 d-flex justify-content-center mt-4'>
                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}
                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);
                    setIsEditMode(false);
                    setForm({
                      type: '',
                      profession: '',
                      type_profession: '',
                      source: ''
                    })
                  }}>
                    Cancel
                  </button>
                </div>

              </div>
            </form>
          </div>
        )}




        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>

            <thead className='table-info'>
              <tr>
                   <th scope='col'>SN</th>
                    <th scope='col'>Action</th>
             
                <th scope='col'>Coupon Name</th>
                <th scope='col'>Coupon Code</th>
                <th scope='col'>Discount Type</th>
                <th scope='col'>Discount Value</th>

            
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((c, index) => (
                  <tr key={index}>
                       <td>{index + 1}</td>
                     <td>
                      <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(c)}><AiOutlineEdit size={18} />

                      </button>


                      <button className='btn btn-sm btn-danger mx-1'
                        onClick={() =>
                          showConfirmDialog({
                            title: 'Delete Coupon',
                            message: `Are you sure you want to delete  this coupon ?`,
                            onConfirm: () => handleDelete(c.id),
                          })
                        }
                      >
                        <AiOutlineDelete size={18} />
                      </button>
                    </td>
                 
                    <td>{c.coupon_name}</td>
                    <td>{c.coupon_code}</td>
                    <td>{c.discount_type}</td>
                    <td>{c.discount_value}</td>


                   
                  </tr>
                ))) : (
                <tr>
                  <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

 <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />


      </div>
    </div>
  )
}

export default Coupon